import GelScene from "../ui/gel/GelScene";
import common from "../common";
import GelHackButton from "../ui/gel/GelHackButton";
import GelButton from "../ui/gel/GelButton";

export default class AchievementScene extends GelScene
{
    constructor()
    {
        super();

        this._achievements = [];
        this._entries = [];
        this._panel = null;
        this._pageIndex = 0;
        this._pageCount = 0;
        this._activeAchievementCount = 0;

        this._achievementsPerPage = 6;
    }

    init()
    {
        super.init();

        this._achievements = P3.utils.objectToArray(common.achievements.achievements);
        this._achievements.sort((x, y) => { return x.id - y.id; });

        const bg = new PIXI.Sprite(P3.assets.texture("ui_results_bg1"));
        bg.width = common.STAGE_WIDTH;
        this.addChild(bg);

        const width = 600;
        const height = 600;

        this._panel = new PIXI.Container();
        this._panel.position.set(common.STAGE_WIDTH * 0.5, P3.View.height * 0.5 + 40);
        this._panel.pivot = new PIXI.Point(width * 0.5, height * 0.5);
        this.addChild(this._panel);

        this._panel.fill = new PIXI.mesh.NineSlicePlane(P3.assets.texture("ui_library_9slice"), 40, 40, 40, 40);
        this._panel.fill.width = width;
        this._panel.fill.height = height;
        this._panel.addChild(this._panel.fill);

        this._panel.title = new PIXI.Sprite(P3.assets.texture("ui_achievements_title"));
        this._panel.title.position.set(width * 0.5, -80);
        this._panel.title.anchor.set(0.5, 0);
        this._panel.addChildAt(this._panel.title, 0);

        this._panel.entries = new PIXI.Container();
        this._panel.addChild(this._panel.entries);

        const style =
            {
                font: {name: "BBC Reith Sans", size: 30},
                tint: 0xFFFFFF,
                align: "center"
            };

        this._panel.title.text = new PIXI.extras.BitmapText("Achievements", style);
        this._panel.title.text.position.set(0, this._panel.title.height * 0.5 - 9);
        this._panel.title.text.anchor.set(0.5);
        this._panel.title.addChild(this._panel.title.text);

        this.initPagePanel();

        this.initAchievements();

        this._pageCount = Math.ceil(this._activeAchievementCount / this._achievementsPerPage);
        this.initPageBlips(this._pageCount);

        this.setPage(0);

        this.initBackButton(GelButton.TAB_INDEX_LEVEL_0);

        // stats
        common.gmi.setStatsScreen && common.gmi.setStatsScreen("achievements");
    }

    destroy()
    {

        super.destroy();
    }

    show()
    {

    }

    hide()
    {

    }

    appear()
    {
        P3.audio.playVO("vo_queen_extra_02a", 1, true);
    }

    animateIn(callback, scope)
    {

    }

    update()
    {

    }

    initPagePanel()
    {
        this._panel.pages = new PIXI.Container();
        this._panel.pages.position.set(this._panel.fill.width - 4, this._panel.fill.height * 0.5);
        this._panel.addChild(this._panel.pages);

        this._panel.pages.image = new PIXI.Sprite(P3.assets.texture("ui_pagination_bg"));
        this._panel.pages.image.height = 300;
        this._panel.pages.addChild(this._panel.pages.image);

        this._panel.pages.blips = new PIXI.Container();
        this._panel.pages.blips.position.set(32, this._panel.pages.image.height * 0.5);
        this._panel.pages.addChild(this._panel.pages.blips);

        this._panel.pages.nextButton = GelHackButton.create(
            P3.assets.texture("ui_btn_page_down_normal"),
            P3.assets.texture("ui_btn_page_down_over"),
            P3.assets.texture("ui_btn_page_down_down")
        );
        this._panel.pages.nextButton.position.set(32, this._panel.pages.image.height);
        this._panel.pages.nextButton.animate = false;
        this._panel.pages.nextButton.animateIcon = false;
        this._panel.pages.nextButton.tabIndex = GelButton.TAB_INDEX_LEVEL_2 - 1;
        this._panel.pages.nextButton.signals.click.add(this.onPageNextButtonClick, this);
        this._panel.pages.addChild(this._panel.pages.nextButton);

        this._panel.pages.previousButton = GelHackButton.create(
            P3.assets.texture("ui_btn_page_up_normal"),
            P3.assets.texture("ui_btn_page_up_over"),
            P3.assets.texture("ui_btn_page_up_down")
        );
        this._panel.pages.previousButton.position.set(32, 0);
        this._panel.pages.previousButton.animate = false;
        this._panel.pages.previousButton.animateIcon = false;
        this._panel.pages.previousButton.tabIndex = GelButton.TAB_INDEX_LEVEL_2 - 2;
        this._panel.pages.previousButton.signals.click.add(this.onPagePreviousButtonClick, this);
        this._panel.pages.addChild(this._panel.pages.previousButton);

        this._panel.pages.pivot.set(0, this._panel.pages.image.height * 0.5);
    }

    initPageBlips(count)
    {
        this._panel.pages.blips.removeChildren();

        const spacing = 220 / count;
        for (let i = 0; i < count; ++i)
        {
            const blip = new PIXI.Sprite(P3.assets.texture("ui_pagination_off"));
            blip.position.set(0, i * spacing - ((count - 1) * spacing) * 0.5);
            blip.anchor.set(0.5);
            this._panel.pages.blips.addChild(blip);
        }
    }

    initAchievements()
    {
        for (let i = 0; i < this._achievements.length; ++i)
        {
            const index = this._pageIndex * this._achievementsPerPage + i;
            const achievement = this._achievements[index];

            if (!common.achievements.isActive(achievement.id))
            {
                continue;
            }

            ++this._activeAchievementCount;

            const entry = new PIXI.mesh.NineSlicePlane(P3.assets.texture("ui_library_slot_equip"), 20, 20, 20, 20);
            entry.width = 520;
            entry.height = 86;
            entry.pivot.set(entry.width * 0.5, 0);
            this._entries.push(entry);

            entry.icon = new PIXI.Sprite(achievement.icon);
            entry.icon.y = (entry.height - entry.icon.height) * 0.5 - 1;
            entry.icon.x = entry.icon.y + 8;
            entry.addChild(entry.icon);

            const style =
                {
                    font: {name: "BBC Reith Sans", size: 24},
                    tint: 0xFFFFFF,
                    align: "left"
                };

            entry.text = new PIXI.extras.BitmapText(achievement.name, style);
            entry.text.position.set(96, 32);
            entry.text.anchor.y = 0.5;
            entry.addChild(entry.text);

            if (entry.text.textWidth > 340)
            {
                entry.text.font.size = 18;
                entry.text.updateText();
            }

            const unlocked = common.achievements.isUnlocked(achievement.id)

            let texture = unlocked ?
                P3.assets.texture("ui_achievement_tick_on") :
                P3.assets.texture("ui_achievement_tick_off");

            entry.tick = new PIXI.Sprite(texture);
            entry.tick.position.set(entry.width - 46, entry.height * 0.5);
            entry.tick.anchor.set(0.5);
            entry.addChild(entry.tick);

            entry.progress = new PIXI.Container();
            entry.progress.position.set(entry.text.x, 60);
            entry.addChild(entry.progress);

            entry.progress.bar = new PIXI.mesh.NineSlicePlane(P3.assets.texture("ui_achievement_progress_bg_9slice"), 8, 8, 8, 8);
            entry.progress.bar.width = 320;
            entry.progress.addChild(entry.progress.bar);

            texture = unlocked ?
                P3.assets.texture("ui_achievement_progress_fill_complete_9slice") :
                P3.assets.texture("ui_achievement_progress_fill_9slice");

            entry.progress.fill = new PIXI.mesh.NineSlicePlane(texture, 8, 8, 8, 8);
            entry.progress.fill.width = 320;
            entry.progress.addChild(entry.progress.fill);

            const progress = common.achievements.getProgress(achievement.id);

            entry.progress.fill.mask = new PIXI.Sprite(PIXI.Texture.WHITE);
            entry.progress.fill.mask.width = entry.progress.fill.width * progress;
            entry.progress.fill.mask.height = entry.progress.fill.height;
            entry.progress.addChild(entry.progress.fill.mask);
        }
    }

    setPage(index)
    {
        this._panel.entries.removeChildren();

        const offset = 36;
        const spacing = 0;

        const start = this._pageIndex * this._achievementsPerPage;
        const end = Math.min(start + this._achievementsPerPage, this._entries.length);

        for (let i = start, j = 0; i < end; ++i, ++j)
        {
            const entry = this._entries[i];
            entry.position.set(this._panel.fill.width * 0.5, offset + (entry.height + spacing) * j);
            this._panel.entries.addChild(entry);
        }

        for (let i = 0; i < this._panel.pages.blips.children.length; ++i)
        {
            const blip = this._panel.pages.blips.children[i];
            blip.texture = i === index ? P3.assets.texture("ui_pagination_on") : P3.assets.texture("ui_pagination_off");
        }
    }

    onPageNextButtonClick(button)
    {
        if (++this._pageIndex > this._pageCount - 1)
        {
            this._pageIndex = this._pageCount - 1;
        }
        this.setPage(this._pageIndex);
    }

    onPagePreviousButtonClick(button)
    {
        if (--this._pageIndex < 0)
        {
            this._pageIndex = 0;
        }
        this.setPage(this._pageIndex);
    }
}